import Vue from "vue";
import {
    FetchState,
    ExpenseByCategoryState,
    ExpenseAmountGroupedByCategory,
    ExpenseAmountByCategory
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import * as expenseService from "@/shared/api/expenseService";
import moment from "moment";
import { defineStore } from "pinia";
import _ from "lodash";
import { useContributionStore } from "@/shared/store/contribution";

const allKey = "All";

export const initialState: ExpenseByCategoryState = {
    fetchState: FetchState.Uninitialized,
    expenseByCategoryDictionary: {},
    currentSelectedKey: allKey
};

//
// Note: this store depends upon the contribution store's getPlanDetails action being called
//

export const useExpenseByCategoryStore = defineStore("expenseByCategory", {
    state: (): ExpenseByCategoryState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
        selectedYearTotal: state =>
            <number>_.get(state.expenseByCategoryDictionary, [ state.currentSelectedKey, "totalExpenseAmount" ], 0),
        selectedYearValues: state => {
            const values: ExpenseAmountByCategory[] =
                _.get(state.expenseByCategoryDictionary, [ state.currentSelectedKey, "expenseAmountByCategories" ], []);
            _.sortBy(values, value => value.amount);
            return values;
        },
        selectedYear: state => state.currentSelectedKey,
        yearOptions () {
            const contributionStore = useContributionStore();
            const options: (number | string)[] = _.range(contributionStore.firstPlanEffectiveYear,
                moment().year() + 1);
            options.push(allKey);
            return options;
        }
    },
    actions: {
        setFetchState (fetchState: FetchState): void {
            this.fetchState = fetchState;
        },
        setExpenseAmountByCategories (data: ExpenseAmountGroupedByCategory): void {
            Vue.set(this.expenseByCategoryDictionary, `${data.year || allKey}`, data);
        },
        setCurrentSeletedKey (key: number | string) {
            this.currentSelectedKey = key;
        },
        changeSelectedYear (selectedYear: number | string): Promise<any> {
            this.setCurrentSeletedKey(selectedYear);
            const yearTotals = this.expenseByCategoryDictionary[selectedYear];

            if (yearTotals && this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);

            return expenseService.getExpenseAmountByCategory(selectedYear === allKey ? null : <number>selectedYear)
                .then(response => {
                    this.setExpenseAmountByCategories(response.data);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
    }
});

